<template>
	<div style="position: relative;">
		<div class="mb-2" style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
			<div style="display: flex;flex-direction: row;align-items: center;line-height: 14px;">
				<b-avatar size="sm" variant="primary" :text="name.charAt(0)" />
				<div class="ml-1">
					{{name}}<br>
					<small v-if="!formatUpdateDatetime">{{formatCreationDatetime}}</small>
					<small v-else >Actualizado: {{formatUpdateDatetime}}</small>
				</div>
			</div>
			<div v-if="optUpdate" class="text-right" style="">
				<div v-if="edit">
					<b-button @click="save" size="sm" variant="primary">{{$t('global.save')}}</b-button>
					<b-button @click="onCancel" size="sm" variant="danger">{{$t('global.cancel')}}</b-button>
				</div>
				<div v-else>
					<b-button size="sm" variant="primary" @click="edit = true"><md-icon icon="edit" /></b-button>
					<b-button size="sm" variant="danger" @click="$emit('onDelete')"><md-icon icon="delete" /></b-button>
				</div>
			</div>
		</div>
		<p v-if="!edit" style="line-height: 18px">{{viewContent}}</p>
		<b-textarea size="sm" v-else v-model="viewContent"></b-textarea>
		<b-overlay :show="loading" no-wrap ></b-overlay>
	</div>
</template>

<script>

export default {
	props:{
		id: {
			type : Number,
			required: true
		},
		reservationId:{
			type : Number,
			required: true
		},
		creationDatetime: {
			type : String,
			required: true
		},
		updateDatetime: {
			type : String,
			required: false,
			default: null,
		},
		name: {
			type : String,
			required: true
		},
		userApp: {
			type : String,
			required: true
		},
		optUpdate: {
			type : Boolean,
			default: false,
		},
		content: {
			type : String,
		},
		activeEdit: {
			type : Boolean,
			required : false,
			default : false,
		},
	},
	components: {  },
	data(){
		return {
			viewContent:'',
			edit:false,
			loading:false,
		}
	},
	computed:{
		formatCreationDatetime: function () {
			return this.creationDatetime ? this.$moment(this.creationDatetime).format("DD/MMMM/YYYY HH:mm:ss") : ''
		},
		formatUpdateDatetime: function () {
			return this.updateDatetime ? this.$moment(this.updateDatetime).format("DD/MMMM/YYYY HH:mm:ss") : ''
		},
	},
	methods:{
		onCancel(){
			if(this.id == -1){
				this.$emit('onDelete')
			}else{
				this.edit = false
			}
		},
		handleModelError(error){
			if(error.response && error.response.status == 422){
				let message = 'Error!'
					Object.keys(error.response.data).forEach(function(key) {
						message = error.response.data[key][0]
					});
				this.$root.showAlert(message,{variant:'danger'})
			}else{
				this.$root.handleRequestError(error)
			}
			this.loading = false;
		},
		save(){
			this.loading = true;
			if(this.id == -1){
				// store
				this.$root.api.post(`/reservation-notes`,{ content:this.viewContent, reservationId: this.reservationId }).then(() => {
					this.loading = false;
					this.edit = false;
					this.$root.showAlert('Nota registrada')
					this.$emit('onSave');
				}).catch(this.handleModelError)

			} else {
				// update
				this.$root.api.put(`/reservation-notes/${this.id}`,{ content:this.viewContent }).then(() => {
					this.loading = false;
					this.edit = false;
					this.$root.showAlert('Actualizacion exitosa')
					this.$emit('onSave');
				}).catch(this.handleModelError)
			}
		}
	},
	mounted(){
		this.viewContent = this.content
		if(this.activeEdit){
			this.edit = true
		}
	}
}
</script>

<style>

</style>
